import { Box, Typography } from '@material-ui/core'
import { Container, LoadingFeedback } from 'components'
import React, { useEffect, useState } from 'react'
import { useLocation, useHistory, useParams } from 'react-router-dom'

import qs from 'query-string'
import { reverse } from 'named-urls'

import useAuth from 'hooks/useAuth'
import useSnackbar from 'hooks/useSnackbar'

import useStyles from './styles'
import * as service from 'service'
import { routes } from 'Routes'
import helpers from 'helpers'

const LoginSSO = () => {
  const classes = useStyles()
  const location = useLocation()
  const history = useHistory()
  const { slug } = useParams()
  const auth = useAuth()
  const snackbar = useSnackbar()

  // Captura no mount: o SSO volta em /dponet/sso (slug hardcoded no backend),
  // então resolvemos pelo organizationSlug salvo antes que o ThemeProvider o
  // limpe, preservando o white-label após o loading.
  const [resolvedSlug] = useState(() => helpers.whiteLabel.resolveSlug(slug))

  const search = qs.parse(location.search)
  const samlAccessCode = search?.saml_access_code || search?.token
  const idpIntentId = search?.id
  const state = search?.state

  const sendSamlAccessCode = async () => {
    try {
      const currentEmailSamlLogin = sessionStorage.getItem(
        'currentEmailSamlLogin',
      )

      const response = await service.dponet.auth.ssoCallback({
        samlAccessCode,
        currentEmailSamlLogin,
        idpIntentId,
        state,
      })

      if (response.status === 202) {
        const accessToken = response.data?.accessToken
        const user = response.data?.user

        history.push({
          pathname: reverse(routes.twoFactorAuthentication, {
            slug: resolvedSlug,
            accessToken,
          }),
          state: {
            email: user?.email,
          },
        })
      } else {
        await auth.loadDataWithAnimation()
      }
    } catch (error) {
      console.error(error)
      sessionStorage.removeItem('currentEmailSamlLogin')
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error, false) ||
          error?.error?.message,
        variant: 'error',
      })
      history.push(reverse(routes.root, { slug: resolvedSlug }))
    }
  }

  useEffect(() => {
    if (samlAccessCode) {
      sendSamlAccessCode()
    }
    // eslint-disable-next-line
  }, [samlAccessCode])

  return (
    <Container maxWidth="sm" className={classes.root}>
      <Box className={classes.boxLoginMicrosoft}>
        <Typography
          variant="h3"
          color="primary"
          className={classes.textLoginMicrosoft}
        >
          Realizando login SSO aguarde...
        </Typography>
      </Box>
      <LoadingFeedback open={true} />
    </Container>
  )
}
export default LoginSSO
